import type { CSSObject } from '@emotion/serialize';
import { changeColorCodeToHex } from '@sds-system/system';
import type { Theme } from '@sds-system/types';

export const processNestedCSS = (css: CSSObject, theme: Theme) => {
  return changeColorCodeToHex(css, theme);
};
